export enum AuditEntityEventType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  StatusChange = 'StatusChange',
}

export enum AuditEntityTypeName {
  ContractEntity = 'ContractEntity',
  ModemEntity = 'ModemEntity',
  CommercialMeteringPointEntity = 'CommercialMeteringPointEntity',
  CommercialMeteringPointOwnershipEntity = 'CommercialMeteringPointOwnershipEntity',
  GasPipelineSectionEntity = 'GasPipelineSectionEntity',
  ActBalanceOwnershipEntity = 'ActBalanceOwnershipEntity',
  ViolationActEntity = 'ViolationActEntity',
  MeteringDeviceEntity = 'MeteringDeviceEntity',
  MeteringPointEntity = 'MeteringPointEntity',
  SealEntity = 'SealEntity',
  GasConsumingEquipmentEntity = 'GasConsumingEquipmentEntity',
  MeteringPointActEntity = 'MeteringPointActEntity',
  CounterpartyEntity = 'CounterpartyEntity',
  ContactPersonEntity = 'ContactPersonEntity',
  OperatingGasRouteEntity = 'OperatingGasRouteEntity',
  SectorBridgeEntity = 'SectorBridgeEntity',
  SectorBridgeActEntity = 'SectorBridgeActEntity',
  ConsumersInformationEntity = 'ConsumersInformationEntity',
  GasRoutePhysicoChemicalIndicatorEntity = 'GasRoutePhysicoChemicalIndicatorEntity',
  CommercialMeteringPointExpenseEntity = 'CommercialMeteringPointExpenseEntity',
  GasThreadOperationalIncomeEntity = 'GasThreadOperationalIncomeEntity',
  ActualIncomeDocumentEntity = 'ActualIncomeDocumentEntity',
}

export type AuditEntity = {
  auditEntryId: string;
  createdAt: string;
  createdBy: string;
  createdByEmail: string;
  createdByName: string;
  entityId: string;
  entityName: string;
  entityTypeName: AuditEntityTypeName;
  eventType: AuditEntityEventType;
};

export type AuditEntityDetails = AuditEntity & {
  previousEntityBody: any;
  currentEntityBody: any;
};

export type AuditEntityType = {
  entityTypeName: string;
  entityDisplayName: string;
};

export type AuditEntityTypeInfo = AuditEntityType & {
  availableEntities: AuditEntityType[];
};
